import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  ctaClickEvent,
  formAbandonmentEvent,
  formFieldErrorEvent,
  formIntermediateEvent,
  formStartEvent,
  formSubmissionFailEvent,
  formSuccessEvent,
} from "../services/adobeDataLayer.js";
import {
  formatAndValidateE164,
  hashValue,
  normalizeEmail,
  setValuesInLocalStorange,
} from "../services/utils.js";

import axios from "axios";
import queryString from "query-string";
import "react-datepicker/dist/react-datepicker.css";

// import ReCAPTCHA from "react-google-recaptcha";
import { callLSQLapp, encryptBody, getLsqLeadBody } from "../services/lsq.js";

function FormComponent() {
  const navigate = useNavigate();
  let cancelToken;

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    reset,
    trigger,
    control,
    setFocus,
    setError,
    clearErrors,
    formState: { errors, isValid },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      residentialStatus: "indian",
    },
  });

  function showToast(type, message) {
    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.textContent = message;

    document.getElementById("toastContainer").appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 4000); // Auto-dismiss after 4 seconds
  }

  useEffect(() => {
    setTimeout(() => {
      const el = document.querySelector('input[name="firstName"]');
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
        el.focus();
      }
    }, 300);
  }, []);

  const [email, setEmail] = useState("");
  const [isEmailEmpty, setIsEmailEmpty] = useState();
  const [showSendOtp, setShowSendOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);
  const [token, setToken] = useState("");
  const [fbp, setFbp] = useState("");
  const [fbc, setFbc] = useState("");

  const [utmDetails, setUtmDetails] = useState({});

  const [company, setCompany] = useState("");
  const [companyName, setCompanyName] = useState("");

  const [companies, setCompanies] = useState([]);

  const [hasAbandoned, setHasAbandoned] = useState(false);
  const [otpSentCount, setOtpSentCount] = useState(0);
  const [disableApplyBtn, setApplyBtnDisable] = useState(false);

  const firstOtpSentTimeRef = useRef(null);
  const companyWrapperRef = useRef(null);

  const empType = watch("emp_type");
  const topCorporate = watch("topCorporate");
  const mobileValue = watch("mobile");
  const employmentType = watch("employmentType");
  const hasITR = watch("hasITR");

  // const companyName = watch("companyName");
  const annualIncome = watch("annualIncome");
  const inputWrapperRef = useRef(null);
  const hasTriggeredFormStart = useRef(false);
  const lastAccessedFieldRef = useRef("");

  //Last Accessed Field
  useEffect(() => {
    const resetAccessField = () => {
      lastAccessedFieldRef.current = "";
    };
    window.addEventListener("beforeunload", resetAccessField);
    return () => window.removeEventListener("beforeunload", resetAccessField);
  }, []);

  // React event for input fields
  const handleChange = async (e) => {
    const fieldName = e.target.name || "unknown";
    lastAccessedFieldRef.current = fieldName;
    if (!hasTriggeredFormStart.current) {
      formStartEvent("no fee lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    setHasAbandoned(false);
  };

  useEffect(() => {
    if (otp.length === 6) {
      handleVerifyOtp();
    }
  }, [otp]);

  // Outside click handler
  useEffect(() => {
    const handleClickOutside = (event) => {
      const wrapper = inputWrapperRef.current;
      if (
        wrapper &&
        !wrapper.contains(event.target) &&
        hasTriggeredFormStart.current &&
        !hasAbandoned
      ) {
        const lastField = lastAccessedFieldRef.current;
        formAbandonmentEvent(
          "no fee lead form",
          "lead generation",
          lastField,
          "details",
        );
        setHasAbandoned(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hasAbandoned]);

  // set Fbp, Fbc, UTM parameters values
  useEffect(() => {
    let retryCount = 0; // Initialize retry counter
    const maxRetries = 5; // Maximum number of retries
    const retryInterval = 3000; // Retry interval in milliseconds

    const fetchCookies = () => {
      const getCookieValue = (cookieName) => {
        return (
          document.cookie
            .split("; ")
            .find((row) => row.startsWith(cookieName))
            ?.split("=")[1] || ""
        );
      };

      const fbpValue = getCookieValue("_fbp");
      const fbcValue = getCookieValue("_fbc");

      // Update state if values are found
      if (fbpValue) setFbp(fbpValue);
      if (fbcValue) setFbc(fbcValue);

      // Retry logic
      if ((!fbpValue || !fbcValue) && retryCount < maxRetries) {
        retryCount++;
        setTimeout(fetchCookies, retryInterval);
      }
    };

    fetchCookies();

    // set UTM parameters
    const getUTMDetails = queryString.parse(window.location.search);

    setUtmDetails(getUTMDetails);
  }, []);

  //OTP Button
  useEffect(() => {
    if (/^\d{10}$/.test(mobileValue)) {
      setShowSendOtp(true);
    } else {
      setShowSendOtp(false);
    }
  }, [mobileValue]);

  // Timer countdown
  useEffect(() => {
    if (otpSent && timer > 0 && !otpVerified) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer, otpVerified]);

  useEffect(() => {
    const handleErrorEvent = (e) => {
      if (hasTriggeredFormStart.current) {
        handleFormFieldErrorEvent(e.detail);
      }
    };

    window.addEventListener("formErrorEvent", handleErrorEvent);

    return () => {
      window.removeEventListener("formErrorEvent", handleErrorEvent);
    };
  }, []);

  useEffect(() => {
    if (companyName !== "Others") {
      setValue("emp_type", "");
    }

    // Reset salaried fields ONLY if user switches away from salaried
    if (employmentType && employmentType !== "salaried") {
      setValue("companyName", "");
      setCompanyName("");
      setCompanies([]);
      setValue("annualIncome", "");
      setValue("emp_type", "");
      setValue("topCorporate", "");
      setValue("CardType", "");
    }

    // Reset self-employed fields ONLY if user switches away
    if (employmentType && employmentType !== "self-employed") {
      setValue("lastYearIncome", "");
      setValue("hasITR", "");
      setValue("emp_type", "");
    }
  }, [employmentType, companyName, setValue]);

  const handleFormFieldErrorEvent = (errorData) => {
    formFieldErrorEvent(errorData);
  };

  function triggerFormErrorEvent(errors) {
    const flatErrors = {};

    Object.keys(errors).forEach((key) => {
      if (errors[key]?.message) {
        flatErrors[key] = errors[key].message;
      }
    });

    if (Object.keys(flatErrors).length === 0) return; // no error, no event

    const event = new CustomEvent("formErrorEvent", {
      detail: flatErrors,
    });

    window.dispatchEvent(event);
  }

  const onError = async (errors) => {
    if (!hasTriggeredFormStart.current) {
      console.log("Calling formStartEvent");
      await formStartEvent("no fee lead form", "lead generation", "details");

      hasTriggeredFormStart.current = true;
    }

    console.log("Calling triggerFormErrorEvent");
    triggerFormErrorEvent(errors);
  };

  const handleFieldFocus = (fieldName) => {
    lastAccessedFieldRef.current = fieldName;
  };

  const OTP_LIMIT = 3;
  const OTP_WINDOW = 10 * 60 * 1000;

  const handleSendOtp = async (source) => {
    if (!mobileValue) return;
    if (mobileValue.length !== 10) return;

    const now = Date.now();

    if (
      !firstOtpSentTimeRef.current ||
      now - firstOtpSentTimeRef.current > OTP_WINDOW
    ) {
      firstOtpSentTimeRef.current = now;
      setOtpSentCount(0);
    }

    if (otpSentCount >= OTP_LIMIT) {
      showToast(
        "error",
        "You have reached the maximum of 3 OTP sends within 10 minutes.",
      );
      return;
    }

    try {
      let payload = { mobile: mobileValue, messageType: "otpGeneral" };
      let param = { otp: "send", productType: "CC" };
      const res = await callLSQLapp(payload, "OTP", param);

      if (res.data.message.response.sent) {
        setOtpSentCount((count) => count + 1);

        if (source === "resend") {
          ctaClickEvent("otp:resend", "lead form", "button", 0, "na");
        } else {
          formIntermediateEvent("send", "otp");
        }

        showToast("success", "An OTP has been sent to your Mobile number.");
        setOtpVerified(false);
        setTimer(60);
        setOtpSent(true);
      }
    } catch (error) {
      showToast("error", "Error occurred while generating OTP.");
    }
  };

  const handleVerifyOtp = async () => {
    if (!mobileValue) {
      showToast("error", "Please enter mobile number");
      return;
    }
    if (otp.length === 6) {
      try {
        let payload = { mobile: mobileValue, otp: otp };
        let param = { otp: "verify", productType: "CC" };
        const otpVerifyResponse = await callLSQLapp(payload, "OTP", param);
        if (
          otpVerifyResponse.data.message ===
          "Failure Occured, please check logs"
        ) {
          showToast("error", "Incorrect OTP");
        } else {
          setOtpVerified(true);
          setTimer(0);
          formIntermediateEvent("verified", "otp");
          showToast("success", "OTP verified.");
          const tokenValue =
            otpVerifyResponse.data.message.response.dataSent.UniqueID;
          setToken(tokenValue);
        }
      } catch (error) {
        showToast("error", "Error verifying OTP.");
      }
    }
  };

  let lastFetchedPrefix = ""; // Keep this at module or component level
  const STORAGE_KEY = "eliteCompany_";

  const setToStorage = (key, data) => {
    localStorage.setItem(
      key,
      JSON.stringify({
        data,
        timestamp: Date.now(),
      }),
    );
  };

  const getFromStorage = (key, ttl = 24 * 60 * 60 * 1000) => {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.timestamp > ttl) {
        localStorage.removeItem(key);
        return null;
      }
      return parsed.data;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  };

  const filterAndAppendOthers = (list, inputValue) => {
    const filtered = list.filter((item) =>
      item.Entity_Name.toLowerCase().startsWith(inputValue.toLowerCase()),
    );

    const hasExactMatch = filtered.some(
      (item) => item.Entity_Name.toLowerCase() === inputValue.toLowerCase(),
    );

    if (!hasExactMatch && inputValue.length > 0) {
      filtered.push({ Entity_Name: "Others", LTF: null });
    }

    return filtered;
  };

  const onCompanyChange = async (e) => {
    const inputValue = e.target.value.trim();
    setCompany(inputValue);

    if (inputValue.length < 2) {
      setCompanies([]);
      return;
    }

    const prefix = inputValue.substring(0, 4).toLowerCase();
    const storageKey = `${STORAGE_KEY}${prefix}`;

    // 1. Try localStorage first
    const cachedData = getFromStorage(storageKey);
    if (cachedData) {
      setCompanies(filterAndAppendOthers(cachedData, inputValue));
      return;
    }

    // 2. Avoid duplicate API calls
    if (prefix === lastFetchedPrefix) return;

    lastFetchedPrefix = prefix;

    if (cancelToken) {
      cancelToken.cancel("Cancelled due to new request");
    }

    cancelToken = axios.CancelToken.source();

    try {
      const payload = { company: inputValue };
      const param = { type: "eliteCompany" };

      const response = await callLSQLapp(payload, "MAVIS", param);
      const { Data = [], Count = 0 } = response.data.message || {};

      if (Count > 0) {
        setToStorage(storageKey, Data);
        setCompanies(filterAndAppendOthers(Data, inputValue));
      } else {
        setCompanies([{ Entity_Name: "Others", LTF: null }]);
      }
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error("Company fetch failed:", error);
      }
    }
  };

  async function Tandc() {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("no fee lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    if (hasTriggeredFormStart.current) {
      ctaClickEvent(
        "Terms & Conditions",
        "lead form",
        "text link",
        0,
        "https://www.icicibank.com/terms-condition/credit-card-terms-and-conditions.page",
      );
    }
  }

  async function MITandC() {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("no fee lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
    if (hasTriggeredFormStart.current) {
      ctaClickEvent(
        "Most Important Terms & Conditions",
        "lead form",
        "text link",
        0,
        "https://www.icicibank.com/managed-assets/docs/personal/cards/MITC_cc.pdf",
      );
    }
  }

  const onSubmit = async (data) => {
    if (mobileValue.length === 10) {
      let errorMessage = "";

      if (!otpSent) {
        errorMessage = "Click on Send OTP to continue";
      } else if (!otp) {
        errorMessage = "Please enter OTP to continue";
      } else if (!otpVerified) {
        errorMessage = "Please verify OTP to continue";
      }
      if (errorMessage) {
        const errorFields = {
          otp: errorMessage,
        };
        formFieldErrorEvent(errorFields);
        showToast("error", errorMessage);
        return;
      }
    }

    if (otpVerified) {
      setApplyBtnDisable(true);
    }

    data.token = token;
    data.Product = "creditcards";
    data.ModeOfLead = "landing-page";
    data.CampaignId = "819038";
    data.CompleteUrl = window.location.href;
    data.FBPixelID = fbp;
    data.FBClickID = fbc;
    data.IsAuthorized = "Yes";
    data.pageType = "topcompany1"; //unique Identifier
    data.User_Agent = navigator.userAgent;
    data.otp = otp;
    data.topCorporate = topCorporate;
    data.typeOfLead = "";
    data.Eligible = "";
    data.CardType = "";

    if (data.employmentType === "salaried") {
      /* Salaried */
      const salariedTopCorporateMap = {
        "below 2,40,000": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "2,40,000 - 5,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "6,00,000 - 8,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "9,00,000 - 17,99,999": {
          CardType: "ICICI Bank Rubyx Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "18,00,000 - 47,99,999": {
          CardType: "ICICI Bank Sapphiro Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "48,00,000 - 2,49,99,999": {
          CardType: "ICICI Bank Sapphiro Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
        "2,50,00,000 and above": {
          CardType: "ICICI Bank Emerald Credit Card",
          Eligible: "Yes",
          typeOfLead: "Top Corporate",
        },
      };

      const salariedNonTopCorporateMap = {
        "below 2,40,000": {
          CardType: "",
          Eligible: "No",
          typeOfLead: "Preferred Corporate",
        },
        "2,40,000 - 5,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "6,00,000 - 8,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "9,00,000 - 17,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "18,00,000 - 47,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "48,00,000 - 2,49,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
        "2,50,00,000 and above": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Preferred Corporate",
        },
      };

      const salariedOtherCorporateMap = {
        "below 2,40,000": {
          CardType: "",
          Eligible: "No",
          typeOfLead: "Others",
        },
        "2,40,000 - 5,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "6,00,000 - 8,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "9,00,000 - 17,99,999": {
          CardType: "ICICI Bank Platinum Chip Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "18,00,000 - 47,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "48,00,000 - 2,49,99,999": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
        "2,50,00,000 and above": {
          CardType: "ICICI Bank Coral Credit Card",
          Eligible: "Yes",
          typeOfLead: "Others",
        },
      };

      // const incomeMap = topCorporate === "yes"
      //     ? salariedTopCorporateMap
      //     : salariedNonTopCorporateMap;
      let incomeMap;

      if (topCorporate === "yes") {
        incomeMap = salariedTopCorporateMap;
      } else if (topCorporate === "others") {
        incomeMap = salariedOtherCorporateMap;
      } else {
        incomeMap = salariedNonTopCorporateMap;
      }

      const result = incomeMap[data.annualIncome];
      if (result) {
        data.CardType = result.CardType;
        data.Eligible = result.Eligible;
        data.typeOfLead = result.typeOfLead;
      }
    } else if (data.employmentType === "self-employed") {
      /* Self-employed */
      if (data.hasITR === "no") {
        data.Eligible = "No";
        data.typeOfLead = "SES";
        data.CardType = "";
      } else {
        const income = Number(data.lastYearIncome);
        if (income < 240000) {
          data.Eligible = "No";
          data.typeOfLead = "SES";
        } else if (income < 1800000) {
          data.CardType = "ICICI Bank Platinum Chip Credit Card";
          data.Eligible = "Yes";
          data.typeOfLead = "SES";
        } else {
          data.CardType = "ICICI Bank Coral Credit Card";
          data.Eligible = "Yes";
          data.typeOfLead = "SES";
        }
      }
    }

    // UTM Params
    const utmParamsObj = queryString.parse(window.location.search);
    for (const [key, value] of Object.entries(utmParamsObj)) {
      data[key] = value;
    }
    localStorage.setItem("data", JSON.stringify(data));
    const formData1 = JSON.parse(localStorage.getItem("data"));
    const mergedObject = { ...formData1, ...data };
    console.log(data);
    let payload = {
      mobile: data.mobile,
      otp: data.otp,
      formdata: getLsqLeadBody(data),
    };

    let param = { productType: "CC" };
    console.log(payload);
    const encryptedPayload = await encryptBody(payload);
    let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
    if (createLeadResp.data.message !== "Failure occured , please check logs") {
      let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
      console.log("leadID", leadid);

      const isSalaried = data.employmentType === "salaried";
      if (data.mobile && data.email) {
        const formattedEmail = normalizeEmail(data.email);
        const hashedEmail = await hashValue(formattedEmail);
        const formattedMobile = formatAndValidateE164(data.mobile);
        const hashedMobile = await hashValue(formattedMobile);
        setValuesInLocalStorange("userData", hashedEmail, hashedMobile);
      }
      // Prepare event payload
      let AdobeEventPayload = {};

      if (isSalaried) {
        AdobeEventPayload = {
          employmentType: data.employmentType,
          company: data.companyName,
          annualIncome: data.annualIncome,
        };
      } else {
        AdobeEventPayload = {
          employmentType: data.employmentType,
          income: data.lastYearIncome,
          ITRStatus: hasITR,
        };
      }

      // Call form success event
      formSuccessEvent(
        "topcompany lead form",
        AdobeEventPayload,
        "lead generation",
        "thank you",
        true,
      );

      // Set localStorage type based on eligibility and employmentType

      // 1 - Not eligible (salaried and low income, self employed and low income, self employed with high income but no ITR)
      // 2 - eligible but self employed, not salaried
      // 3 - eligible and salaried
      if (data.Eligible === "Yes") {
        localStorage.setItem("type", isSalaried ? 3 : 2);
        // localStorage.setItem("type", 3);
      } else {
        localStorage.setItem("type", 1);
      }

      // Navigate to thank you page
      navigate(`/thankyou?id=${leadid}`);
    } else {
      formSubmissionFailEvent();
      setApplyBtnDisable(false);
      showToast("error", "Error Occured, Please try again after sometime");
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit, onError)} id="myForm">
      <h3>Fill the form below</h3>
      <div className="px-3" ref={inputWrapperRef}>
        {/* Full Name */}
        <div className="d-md-flex gap-2 name-wrap">
          <div className="input_wrapper">
            <input
              type="text"
              id="firstName"
              placeholder="First Name"
              className="mt-0"
              disabled={otpVerified}
              onFocus={() => handleFieldFocus("firstName")}
              {...register("firstName", {
                required: "First name is required",
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "Only alphabets and spaces allowed",
                },
              })}
              onInput={(e) => {
                handleChange(e);
                e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              }}
            />

            {errors.firstName && (
              <span className="error">{errors.firstName.message}</span>
            )}
          </div>
          <div className="input_wrapper">
            <input
              type="text"
              id="name"
              placeholder="Last Name"
              disabled={otpVerified}
              onFocus={() => handleFieldFocus("lastName")}
              {...register("lastName", {
                required: "Last name is required",
                pattern: {
                  value: /^[a-zA-Z\s]+$/,
                  message: "Only alphabets and spaces allowed",
                },
              })}
              onInput={(e) => {
                handleChange(e);
                e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
              }}
            />
            {errors.lastName && (
              <span className="error">{errors.lastName.message}</span>
            )}
          </div>
        </div>
        <p className="label">Name (As per PAN)</p>

        {/* Mobile Number */}
        <div className=" otp_wrapper input_wrapper">
          <div className="d-flex align-items-center gap-2 ">
            <input
              type="text"
              id="mobile"
              placeholder="Mobile Number"
              disabled={otpVerified}
              onFocus={() => handleFieldFocus("Mobile")}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={10}
              {...register("mobile", {
                required: "Mobile number is required",
                pattern: {
                  value: /^[0-9]{10}$/,
                  message: "Enter valid 10-digit mobile number",
                },
              })}
              onInput={(e) => {
                handleChange(e);
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
            />
            <div className="input_wrapper">
              {otpVerified ? (
                <button
                  type="button"
                  className="resend otp-verified"
                  id=""
                  disabled
                >
                  OTP Verified
                </button>
              ) : (
                !otpSent &&
                !otpVerified && (
                  <button
                    type="button"
                    className="resend"
                    id="sendOtpBtn"
                    onClick={() => handleSendOtp("send")}
                  >
                    Send OTP
                  </button>
                )
              )}
            </div>
          </div>
          {errors.mobile && (
            <span className="error">{errors.mobile.message}</span>
          )}
        </div>

        {/* OTP Field */}
        {otpSent && !otpVerified && (
          <div className="otp_wrapper input_wrapper">
            <div className="d-flex align-items-center gap-2 ">
              <input
                type="text"
                id="otp"
                onFocus={() => handleFieldFocus("otp")}
                placeholder="Enter the OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                inputMode="numeric"
              />
              <span className="timer">
                {timer < 10 ? `00:0${timer}` : `00:${timer}`}
              </span>
              {timer <= 0 && (
                <button
                  type="button"
                  className="resend"
                  id="resendBtn"
                  onClick={() => handleSendOtp("resend")}
                >
                  Resend
                </button>
              )}
            </div>
            {errors.otp && <span className="error">{errors.otp.message}</span>}
          </div>
        )}

        <div className="input_wrapper">
          <input
            type="text"
            placeholder="Email"
            onFocus={() => handleFieldFocus("email")}
            id="email"
            list="email-options"
            autoComplete="off"
            value={email}
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Enter valid email",
              },
              onChange: (e) => {
                handleChange(e);
                setEmail(() => e.target.value);
                setIsEmailEmpty(false);
                const data = e.target.value;
                if (data.includes(".com") || data.includes("co.in")) {
                  setIsEmailEmpty(true);
                } else {
                  setIsEmailEmpty(false);
                }
              },
            })}
          />
          {email.length > 2 ? (
            !isEmailEmpty ? (
              <datalist id="email-options">
                <option value={`${email}@gmail.com`}></option>
                <option value={`${email}@yahoo.com`}></option>
                <option value={`${email}@rediffmail.com`}></option>
                <option value={`${email}@yahoo.co.in`}></option>
                <option value={`${email}@icloud.com`}></option>
                <option value={`${email}@outlook.com`}></option>
              </datalist>
            ) : null
          ) : null}

          {errors.email && (
            <span className="error">{errors.email.message}</span>
          )}
        </div>

        <div className="position-relative input_wrapper">
          <select
            id="qualification"
            {...register("occupation", {
              required: "Select your Qualification",
            })}
            defaultValue=""
            onFocus={() => handleFieldFocus("occupation")}
            className={`custom-dropdown black-dropdown`}
          >
            <option value="" disabled>
              Qualification
            </option>
            <option value="post_graduate">Post Graduate</option>
            <option value="graduate">Graduate</option>
            <option value="professional_diploma">Professional Diploma</option>
            <option value="undergraduate">Undergraduate</option>
            <option value="ssc">SSC</option>
            <option value="below_ssc">Below SSC</option>
          </select>
          <img
            src="dist/img/icons/down.svg"
            className="arrow"
            width="18"
            alt="arrow"
          />
          {errors.occupation && (
            <span className="error">{errors.occupation.message}</span>
          )}
        </div>

        <div className="position-relative input_wrapper">
          <select
            id="occupation"
            {...register("employmentType", {
              required: "Select your profession",
            })}
            defaultValue=""
            onFocus={() => handleFieldFocus("empoyment type")}
            className={`custom-dropdown black-dropdown ${employmentType ? "filled" : "placeholder"}`}
          >
            <option value="" disabled>
              Profession
            </option>
            <option value="salaried">Salaried</option>
            <option value="self-employed">Self Employed</option>
          </select>
          <img
            src="dist/img/icons/down.svg"
            className="arrow"
            width="18"
            alt="arrow"
          />
          {errors.employmentType && (
            <span className="error">{errors.employmentType.message}</span>
          )}
        </div>

        {employmentType === "self-employed" && (
          <>
            <input
              type="text"
              id="lastYearIncome"
              onFocus={() => handleFieldFocus("lastYearIncome")}
              placeholder="Enter your last year's annual income"
              inputMode="numeric"
              {...register("lastYearIncome", {
                required: "Annual income is required",
                pattern: {
                  value: /^[0-9,]+$/, // allow commas
                  message: "Only numbers are allowed",
                },
                setValueAs: (value) => value.replace(/,/g, ""), // remove commas before storing
              })}
              onChange={(e) => {
                handleChange(e);
                const raw = e.target.value.replace(/\D/g, ""); // remove all non-digits
                const formatted = raw.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // format with commas
                e.target.value = formatted;
                e.target.dispatchEvent(new Event("input", { bubbles: true }));
              }}
              onKeyPress={(e) => {
                if (!/[0-9]/.test(e.key)) {
                  e.preventDefault(); // block non-numeric input
                }
              }}
            />

            <div className="position-relative input_wrapper">
              <select
                id="itr"
                {...register("hasITR", {
                  required: "Select ITR option",
                })}
                onFocus={() => handleFieldFocus("hasITR")}
                defaultValue=""
                // className={hasITR ? "filled" : "placeholder"}
                className={`custom-dropdown black-dropdown ${hasITR ? "filled" : "placeholder"}`}
              >
                <option value="" disabled>
                  Do you have last year's ITR
                </option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <img
                src="dist/img/icons/down.svg"
                className="arrow"
                width="18"
                alt="arrow"
              />
              {errors.hasITR && (
                <span className="error">{errors.hasITR.message}</span>
              )}
            </div>
          </>
        )}

        {employmentType === "salaried" && (
          <>
            <div
              className="position-relative input_wrapper"
              ref={companyWrapperRef}
            >
              <input
                className="input-box"
                type="text"
                name="company"
                placeholder="Enter Company"
                autoComplete="off"
                value={companyName}
                onFocus={() => {
                  handleFieldFocus("company");
                  // handleLocalCompanyFocus(e); // 👈 show list on focus
                }}
                {...register("companyName", {
                  required: "This field is required",
                  onChange: (e) => {
                    handleChange(e);
                    const inputVal = e.target.value;
                    setCompanyName(inputVal);
                    onCompanyChange(e);
                    // handleLocalCompanyChange(e); // 👈 filter list
                    // setShowOtherCompanyInput(false);
                  },
                })}
              />

              {companies.length > 0 && (
                <ul className="companydropDown">
                  {companies.map((item) => (
                    <li
                      key={item.Entity_Name}
                      className="company-List"
                      onClick={(e) => {
                        // e.preventDefault();
                        setCompanyName(item.Entity_Name);
                        setValue("companyName", item.Entity_Name);
                        if (item.Entity_Name === "Others") {
                          // setShowOtherCompanyInput(true);
                          setValue("topCorporate", "others");
                          // setLocalCompanyInput("Others");
                        } else {
                          console.log(item.Top_Corporate);
                          // setLocalCompanyInput(item.name);
                          setValue("topCorporate", item.Top_Corporate);
                        }

                        setValue("companyName", item.Entity_Name, {
                          shouldValidate: true,
                          shouldTouch: true,
                        });

                        setCompanies([]);
                      }}
                    >
                      {item.Entity_Name}
                    </li>
                  ))}
                </ul>
              )}

              {errors.companyName && (
                <span className="error">{errors.companyName.message}</span>
              )}
              {companyName === "Others" && (
                <div className="position-relative input_wrapper">
                  <select
                    id="emp_type"
                    value={empType || ""}
                    {...register("emp_type", {
                      required: "Select your Employment Type",
                    })}
                    onFocus={() => handleFieldFocus("emp_type")}
                    className={`custom-dropdown black-dropdown`}
                  >
                    <option value="" disabled>
                      Employment Type
                    </option>
                    <option value="Government">Government</option>
                    <option value="Private_Limited">Private Limited</option>
                    <option value="Public_Limited">Public Limited</option>
                    <option value="Multinational">Multinational</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Proprietorship">Proprietorship</option>
                  </select>
                  <img
                    src="dist/img/icons/down.svg"
                    className="arrow"
                    width="18"
                    alt="arrow"
                  />
                  {errors.emp_type && (
                    <span className="error">{errors.emp_type.message}</span>
                  )}
                </div>
              )}
            </div>

            <div className="position-relative input_wrapper">
              <select
                id="annualincome"
                {...register("annualIncome", {
                  required: "Select annual income",
                })}
                onFocus={() => handleFieldFocus("annualIncome")}
                defaultValue=""
                className={`custom-dropdown black-dropdown ${annualIncome ? "filled" : "placeholder"}`}
              >
                <option value="" disabled>
                  Annual Income
                </option>
                <option value="below 2,40,000">below ₹2,40,000</option>
                <option value="2,40,000 - 5,99,999">
                  ₹2,40,000 - ₹5,99,999
                </option>
                <option value="6,00,000 - 8,99,999">
                  ₹6,00,000 - ₹8,99,999
                </option>
                <option value="9,00,000 - 17,99,999">
                  ₹9,00,000 - ₹17,99,999
                </option>
                <option value="18,00,000 - 47,99,999">
                  ₹18,00,000 - ₹47,99,999
                </option>
                <option value="48,00,000 - 2,49,99,999">
                  ₹48,00,000- ₹2,49,99,999
                </option>
                <option value="2,50,00,000 and above">
                  ₹2,50,00,000 and above
                </option>
              </select>
              <img
                src="dist/img/icons/down.svg"
                className="arrow"
                width="18"
                alt="arrow"
              />
              {errors.annualIncome && (
                <span className="error">{errors.annualIncome.message}</span>
              )}
            </div>
          </>
        )}

        <div className="input_wrapper">
          <input
            type="text"
            id="pan"
            placeholder="PAN Number"
            onFocus={() => handleFieldFocus("pan")}
            maxLength={10}
            {...register("pan", {
              required: "PAN number is required",
              pattern: {
                value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                message: "Invalid PAN format",
              },
            })}
            onInput={(e) => {
              handleChange(e);
              e.target.value = e.target.value.toUpperCase();
            }}
          />

          {errors.pan && <span className="error">{errors.pan.message}</span>}
        </div>

        <div className="position-relative input_wrapper residential-status d-flex justify-content-between align-items-center">
          <p className="field-label">Residential Status</p>

          <div className="d-flex align-items-center gap-4">
            <label className="radio-wrapper">
              <input
                type="radio"
                value="indian"
                // checked
                {...register("residentialStatus", {
                  required: "Please select residential status",
                })}
              />
              <span className="custom-radio"></span>
              Indian
            </label>

            <label className="radio-wrapper">
              <input
                type="radio"
                value="NRI"
                {...register("residentialStatus", {
                  required: "Please select residential status",
                })}
              />
              <span className="custom-radio"></span>
              NRI
            </label>
          </div>

          {errors.residentialStatus && (
            <span className="error">{errors.residentialStatus.message}</span>
          )}
        </div>
        <div
          className="position-relative input_wrapper d-flex align-items-start justify-content-center mt-3 agreetncwrap"
          style={{ gap: "10px" }}
        >
          <Controller
            name="agreetnc"
            control={control}
            defaultValue={false}
            rules={{
              validate: (value) =>
                value === true ||
                "Please agree to our Terms & Conditions to proceed.",
            }}
            render={({ field }) => (
              <input
                type="checkbox"
                id="agreetnc"
                style={{ width: "fit-content" }}
                checked={field.value}
                onChange={(e) => field.onChange(e.target.checked)}
              />
            )}
          />

          <p>
            I agree to ICICI Bank's{" "}
            <a
              href="https://www.icicibank.com/personal-banking/cards/credit-card/documents"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => Tandc()}
            >
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a
              href="https://www.icicibank.com/managed-assets/docs/personal/cards/MITC_cc.pdf"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => MITandC()}
            >
              Most Important Terms & Conditions
            </a>{" "}
          </p>
        </div>
        {errors.agreetnc && (
          <span className="error">{errors.agreetnc.message}</span>
        )}
        <button
          id="proceed"
          type="submit"
          className={`proceed ${!isValid ? "disabled" : ""}`}
          disabled={disableApplyBtn}
          style={{ backgroundColor: disableApplyBtn ? "grey" : "" }}
        >
          {disableApplyBtn ? "Submitting..." : "Apply Now"}{" "}
        </button>
        <div className="toast-container" id="toastContainer"></div>
      </div>
    </form>
  );
}

export default FormComponent;
